import React, {useEffect, useState} from 'react';
import RiskListItem from './RiskListItem';
import styled from 'styled-components';
import _ from 'lodash';

export default function RisksList(props) {
	const {risksList, isDisplayAccounts, getBodiesBySectionId, isDisabled} = props;
	const [risksOrderByName, setRisksOrderByName] = useState([]);

	useEffect(() => {
		setRisksOrderByName(_.orderBy(risksList, ['riskName'], ['asc']));
	}, [risksList]);

	return (
		<>
			<StyledRisksList className="StyledRisksList">
				{risksOrderByName.map((risk) => (
					<RiskListItem
						key={risk.id}
						risk={risk}
						isDisplayAccounts={isDisplayAccounts}
						getBodiesBySectionId={getBodiesBySectionId}
						isDisabled={isDisabled}
					/>
				))}
			</StyledRisksList>
		</>
	);
}

const StyledRisksList = styled.ul`
	font-size: var(--px-14);
	list-style: none !important;
`;
